<template>
  <div
    class="data-card flex flex-col justify-center items-center text-$textColorDefault text-16px h-56px relative"
  >
    <div class="w-full h-1px absolute top-0 left-0" :style="{ backgroundColor: color }"></div>
    <div class="text-14px">{{ title }}</div>
    <div class="flex justify-center items-center mt-5px">
      <span class="flex-1 truncate text-20px mr-5px" :style="{ color }">{{ num }}</span>
      <span class="text-12px">{{ unit }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#fff',
    },
    title: {
      type: String,
      default: '--',
    },
    num: {
      type: Number,
      default: 0,
    },
    unit: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.data-card {
  background-image: var(--DataCardBg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center 0;
}
</style>
